import React from 'react';
import {Typography} from '@mui/material'
import {PageContainer} from "../survey-tools/ui-components/containers"

function ConsentForm() {
  return (
    <PageContainer>
      <div style={{ margin: '20px' }}>
        <Typography variant="h3" style={{ textAlign: 'center' }} gutterBottom>
          Consent Form
        </Typography>
        <div style={{ textAlign: 'left' }}>

          <Typography gutterBottom>
            <strong>You are being asked to participate in a research study. Please read this consent form carefully before deciding whether you would like to participate in this study.</strong>
          </Typography>

          <div style={{ height: '10px' }}></div> 

          <Typography gutterBottom>
            To participate, it is necessary that your device has a microphone as you will be asked to record audio responses.
          </Typography>

          <div style={{ height: '10px' }}></div> 

          <Typography gutterBottom>
            <strong>Purpose of the study:</strong> We are interested in learning more about how the mind moves from one thought to the next.
          </Typography>

          <div style={{ height: '10px' }}></div> 

          <Typography gutterBottom>
            <strong>What you will do in this study:</strong> During this study you will be asked to recall and write about a personal event. You will be asked to complete a series of tasks and surveys in which you will answer questions and provide ratings. You will also be asked to speak your thoughts out loud, while being recorded by the device’s microphone (audio only).
          </Typography>

          <div style={{ height: '10px' }}></div> 

          <Typography gutterBottom>
            <strong>Time required:</strong> The study will take approximately 30 minutes to complete.
          </Typography>

          <div style={{ height: '10px' }}></div> 

          <Typography gutterBottom>
            <strong>Risks and benefits:</strong> There are no anticipated risks associated with being in this study. Some of the questions may cause discomfort or stress. You are free to skip any questions or stop participating at any time throughout the study. At the end of the study, we provide a thorough explanation of the study. Although we hope the results of this study will benefit society, you may not directly benefit from taking part in this research. We hope this study will provide you with the opportunity to learn about the research process.
          </Typography>

          <div style={{ height: '10px' }}></div> 

          <Typography gutterBottom>
            <strong>Compensation:</strong> You will receive $6 for completing this survey, which will be awarded through your Prolific account.
          </Typography>

          <div style={{ height: '10px' }}></div> 

          <Typography gutterBottom>
            <strong>Confidentiality:</strong> All records from this study will be kept confidential. Your responses will be kept private, and we will not include any information that will make it possible to identify you in any report we might publish. Research records will be stored securely on password-protected computers or servers. The research team will be the only party that will have access to your data.
          </Typography>

          <div style={{ height: '10px' }}></div> 

          <Typography gutterBottom>
            <strong>Participation and withdrawal:</strong> Your participation in this study is completely voluntary. You may withdraw at any time without penalty by simply closing or redirecting your browser's tab (no questions will be asked). If you withdraw from the study, you can email faustine@princeton.edu, and you will still receive the promised monetary compensation and a detailed explanation of the study’s aims.
          </Typography>

          <div style={{ height: '10px' }}></div> 

          <Typography gutterBottom>
            <strong>To contact the researcher:</strong> If you have any questions about this study, please contact Faustine Corbani (faustine@princeton.edu). Principal Investigator: Diana Tamir (dtamir@princeton.edu), Peretsman-Scully Hall, Department of Psychology, Princeton University.
          </Typography>

          <div style={{ height: '10px' }}></div> 


          <Typography gutterBottom>
            <strong>Agreement:</strong> The purpose and nature of this research have been sufficiently explained and I agree to participate in this study. I understand that I am free to withdraw at any time without incurring any penalty.
          </Typography>

          <div style={{ height: '10px' }}></div> 

          <Typography gutterBottom>
            <strong>This study has been approved by the Institutional Review Board for Human Subjects.</strong>
          </Typography>

        </div>
      </div>
    </PageContainer>
  );
}


export default ConsentForm;

